// Native Shopify contact forms own acceptance, captcha and email delivery.
window.VALENI_FORMS = Object.assign({submit:null}, window.VALENI_FORMS);
(() => {
  'use strict';
  const config = window.VALENI_FORMS;
  const page = JSON.parse(document.querySelector('#commerce-data')?.textContent || '{}');
  const contactDialog = document.querySelector('[data-contact-dialog]');
  const reviewDialog = document.querySelector('[data-review-dialog]');
  const contactForm = document.querySelector('[data-customer-form="contact"]');
  const contactInline = document.querySelector('[data-contact-inline]');
  const desktop = matchMedia('(min-width: 900px)');
  const returnFocus = new WeakMap();
  function open(dialog, trigger) {
    if (!dialog || dialog.open) return;
    returnFocus.set(dialog, trigger);
    dialog.showModal();
    dialog.querySelector('input')?.focus({preventScroll:true});
  }
  document.querySelector('[data-review-open]')?.addEventListener('click', e => open(reviewDialog, e.currentTarget));
  document.querySelector('[data-contact-open]')?.addEventListener('click', e => open(contactDialog, e.currentTarget));
  document.querySelectorAll('.form-dialog').forEach(dialog => {
    dialog.querySelector('[data-form-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => returnFocus.get(dialog)?.focus({preventScroll:true}));
    dialog.addEventListener('click', e => {
      const rect = dialog.getBoundingClientRect();
      if (e.target === dialog && (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom)) dialog.close();
    });
  });
  function moveContactForm() {
    if (!contactForm) return;
    if (desktop.matches || document.body.classList.contains('page-home')) {
      const wasOpen = contactDialog.open;
      if (wasOpen) contactDialog.close();
      contactInline.append(contactForm);
      if (wasOpen) contactForm.querySelector('input').focus({preventScroll:true});
    } else contactDialog.querySelector('[data-contact-mount]').append(contactForm);
  }
  moveContactForm();

  desktop.addEventListener('change', moveContactForm);
  const draftKey = 'valeni-form:' + location.pathname;
  let pending;
  try { pending = JSON.parse(sessionStorage.getItem(draftKey)); if (Date.now() - pending?.at > 1800000) { sessionStorage.removeItem(draftKey); pending = null; } } catch {}
  document.querySelectorAll('[data-customer-form]').forEach(form => {
    const type = form.dataset.customerForm;
    const result = form.querySelector('[data-review-result], [data-contact-result]');
    const accepted = form.querySelector('[data-review-accepted], [data-contact-accepted]');
    const belongs = pending?.type === type || (!pending && location.hash === '#' + form.id);
    if (result) result.hidden = !belongs;
    if (belongs && accepted) {
      try { sessionStorage.removeItem(draftKey); } catch {}
    } else if (belongs && pending) {
      Object.entries(pending.fields || {}).forEach(([name,value]) => {
        const field = form.elements.namedItem(name);
        if (field && !name.includes('website') && !name.includes('product')) field.value = value;
      });
    }
    if (belongs && type === 'contact' && !desktop.matches && !document.body.classList.contains('page-home')) open(contactDialog, document.querySelector('[data-contact-open]'));
    if (belongs && type === 'review') open(reviewDialog, document.querySelector('[data-review-open]'));

    const status = form.querySelector('[data-form-status]');
    const button = form.querySelector('[type=submit]');
    button.disabled = false;
    
    let sending = false;
    addEventListener('pageshow', () => { sending = false; button.disabled = false; form.removeAttribute('aria-busy'); });
    form.addEventListener('input', e => {
      e.target.setCustomValidity?.('');
      if (e.target.type === 'radio') form.querySelectorAll('input[type=radio]').forEach(input => input.setCustomValidity(''));
      status.textContent = '';
    });
    form.addEventListener('invalid', e => {
      const input = e.target;
      if (input.validity.valueMissing) input.setCustomValidity(window.valeniT('js_required'));
      else if (input.validity.typeMismatch) input.setCustomValidity(window.valeniT('js_invalid_email'));
      else if (input.validity.tooShort) input.setCustomValidity(window.valeniT('js_min_length', {n:input.minLength}));
    }, true);
    form.addEventListener('submit', async e => {
      if (sending) { e.preventDefault(); return; }
      const native = form.hasAttribute('data-native-contact');
      if (!native) e.preventDefault();
      form.querySelectorAll('input:not([type=radio]):not([type=hidden]):not([data-honeypot]), textarea').forEach(input => {
        const value = input.value.trim();
        input.setCustomValidity(!value ? window.valeniT('js_required') : (input.minLength > 0 && value.length < input.minLength ? window.valeniT('js_min_length', {n:input.minLength}) : ''));
      });
      if (!form.reportValidity()) { e.preventDefault(); return; }
      if (native) {
        const timestamp = form.querySelector('[data-submitted-at]');
        if (timestamp) timestamp.value = new Date().toISOString();
        try { sessionStorage.setItem(draftKey, JSON.stringify({type, at:Date.now(), fields:Object.fromEntries(new FormData(form))})); } catch {}
        if (form.querySelector('[data-honeypot]')?.value) { e.preventDefault(); status.textContent = window.valeniT('js_contact_error'); return; }
        queueMicrotask(() => {
          // Respect Shopify captcha middleware that may defer the native POST.
          if (e.defaultPrevented) return;
          // Preserve the draft across native validation/captcha/network navigation.
          // It is scoped to this tab/product and expires after 30 minutes.
          try { sessionStorage.setItem(draftKey, JSON.stringify({type, at:Date.now(), fields:Object.fromEntries(new FormData(form))})); } catch {}
          sending = true; button.disabled = true; form.setAttribute('aria-busy','true'); status.textContent = window.valeniT('js_sending');
          setTimeout(() => { sending = false; button.disabled = false; form.removeAttribute('aria-busy'); }, 15000);
        });
        return; // Shopify's native POST, captcha and server response own success/failure.
      }
      if (typeof config.submit !== 'function') {
        status.textContent = form.dataset.customerForm === 'review'
          ? window.valeniT('js_review_preview')
          : window.valeniT('js_contact_preview');
        return;
      }
      const fields = Object.fromEntries([...new FormData(form)].map(([key,value]) => [key, String(value).trim()]));
      if (fields.rating) fields.rating = Number(fields.rating);
      if (form.dataset.customerForm === 'review') {
        if (!page.productId) { status.textContent = window.valeniT('js_review_product_missing'); return; }
        fields.productId = page.productId; fields.productKey = page.productKey;
      }
      sending = true; button.disabled = true; form.setAttribute('aria-busy', 'true'); status.textContent = window.valeniT('js_sending');
      const controller = new AbortController();
      let timeout;
      try {
        const result = await Promise.race([
          config.submit({type:form.dataset.customerForm, fields, signal:controller.signal}),
          new Promise((_,reject) => { timeout = setTimeout(() => { controller.abort(); reject(new Error('timeout')); },15000); })
        ]);
        if (result?.accepted !== true) throw new Error('not-accepted');
        // Acknowledgement is not a claim of email delivery or verified purchase.
        status.textContent = type === 'review' ? window.valeniT('js_review_success') : window.valeniT('js_form_success');
        form.reset();
      } catch {
        status.textContent = window.valeniT('js_form_unconfirmed');
      } finally {
        clearTimeout(timeout); sending = false; button.disabled = false; form.removeAttribute('aria-busy');
      }
    });
  });
})();
